import * as _ from 'lodash'
import {PAdbContext} from "../PA.Core/PAdbContext";
import {WB_PeriodTypeRow} from "../PA.Core/PAdbSchemaRows";
import * as AsyncLock from 'async-lock';
import {esWB_Period_Type} from "../PA.Core/PAdbSchema";
import {ILease} from "../PA.Utils/PA.UtilsIF";
import {GenericLease} from '../PA.Utils/GenericLease';
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";

export class PeriodTypeService {

    private static _dbContext: PAdbContext;
    private static _lease: ILease;

    private static dctPeriodTypeByWBId: { [id: number]: WB_PeriodTypeRow } = {};
    private static dctPeriodTypeByPeriodType: { [id: string]: WB_PeriodTypeRow } = {};

    private static dctLock: any = new AsyncLock();

    private static bIsLoaded: boolean = false;

    static getPeriodTypeByWBID(periodTypeWBID: number): Promise<WB_PeriodTypeRow> {

        return new Promise<WB_PeriodTypeRow>((resolve, error) => {

            PeriodTypeService.dctLock.acquire('global',
                (done: any) => {

                    PeriodTypeService.checkLease()
                        .then((ignore) => {
                            if (periodTypeWBID in PeriodTypeService.dctPeriodTypeByWBId) {
                                done(null, PeriodTypeService.dctPeriodTypeByWBId[periodTypeWBID]);
                                resolve(PeriodTypeService.dctPeriodTypeByWBId[periodTypeWBID]);
                                return;
                            } else if (PeriodTypeService.bIsLoaded && !(periodTypeWBID in PeriodTypeService.dctPeriodTypeByPeriodType)) {
                                done(null, PeriodTypeService.dctPeriodTypeByWBId[periodTypeWBID]);
                                resolve(undefined);
                                return;
                            }

                            PeriodTypeService.loadFromDB()
                                .then((res) => {
                                    done(null, PeriodTypeService.dctPeriodTypeByWBId[periodTypeWBID]);
                                    return PeriodTypeService.dctPeriodTypeByWBId[periodTypeWBID];
                                })
                                .then((targetType) => {
                                    resolve(targetType);
                                })
                                .catch((err2) => {
                                    error(err2);
                                })
                        })
                        .catch((err) => {
                            error(err);
                        })
                }
            );
        })
    }

    static getPeriodTypeByTypeID(periodType: string): Promise<WB_PeriodTypeRow> {
        return new Promise<WB_PeriodTypeRow>((resolve, error) => {


            PeriodTypeService.dctLock.acquire('global',
                (done: any) => {

                    PeriodTypeService.checkLease()
                        .then((ignore) => {
                            if (periodType in PeriodTypeService.dctPeriodTypeByPeriodType) {
                                done(null, PeriodTypeService.dctPeriodTypeByPeriodType[periodType]);
                                resolve(PeriodTypeService.dctPeriodTypeByPeriodType[periodType]);
                                return;
                            } else if (PeriodTypeService.bIsLoaded && !(periodType in PeriodTypeService.dctPeriodTypeByPeriodType)) {
                                done(null, PeriodTypeService.dctPeriodTypeByPeriodType[periodType]);
                                resolve(undefined);
                                return;
                            }

                            PeriodTypeService.loadFromDB()
                                .then((res) => {
                                    done(null, PeriodTypeService.dctPeriodTypeByPeriodType[periodType]);
                                    return PeriodTypeService.dctPeriodTypeByPeriodType[periodType];
                                })
                                .then((targetType) => {
                                    resolve(targetType);
                                })
                                .catch((err2) => {
                                    error(err2);
                                })
                        })
                        .catch((err) => {
                            error(err);
                        })

                }
            )
        })
    }

    static loadFromDB(): Promise<void> {
        return new Promise<void>((resolve, error) => {

            PeriodTypeService.bIsLoaded = false;

            if (_.isUndefined(PeriodTypeService._dbContext)) {
                PeriodTypeService.instantiateDbContext();
            }

            PeriodTypeService._dbContext.findAll(esWB_Period_Type, {})
                .then((conditions) => {
                    if (_.isArray(conditions)) {
                        let rows = conditions as WB_PeriodTypeRow[];

                        _.forEach(rows, (row) => {
                            PeriodTypeService.dctPeriodTypeByWBId[row.cif.WB_PERIODM_ID] = row;
                            PeriodTypeService.dctPeriodTypeByPeriodType[row.cif.PERIOD_TYPE_ID] = row;
                        })
                    }
                    PeriodTypeService.bIsLoaded = true;
                    PeriodTypeService._lease.resetLease();
                    resolve();
                })
                .catch((err) => {
                    error(err);
                })

        })
    }

    private static async checkLease() {

        if (_.isUndefined(PeriodTypeService._lease)) {
            PeriodTypeService._lease = new GenericLease(LeaseRegistry.Lease_Type_PeriodType);
        }

        if (await PeriodTypeService._lease.hasDataChanged()) {
            await PeriodTypeService.reset();
        }
    }

    static async reset() {
        PeriodTypeService.instantiateDbContext();

        let arr: WB_PeriodTypeRow[] = [];
        arr.push.apply(arr, _.values(PeriodTypeService.dctPeriodTypeByWBId));
        await PeriodTypeService._dbContext.purgeCache(esWB_Period_Type, arr);

        PeriodTypeService.dctPeriodTypeByPeriodType = {};
        PeriodTypeService.dctPeriodTypeByWBId = {};
        PeriodTypeService.bIsLoaded = false;
    }

    private static instantiateDbContext() {
        PeriodTypeService._dbContext = new PAdbContext();
    }

}
